/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type GetBackAttivitaV2IdComunicazioniStato =
  (typeof GetBackAttivitaV2IdComunicazioniStato)[keyof typeof GetBackAttivitaV2IdComunicazioniStato];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBackAttivitaV2IdComunicazioniStato = {
  IN_BOZZA: 'IN_BOZZA',
  INVIATA: 'INVIATA',
} as const;
